// Components==============
import { motion } from 'framer-motion';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { useTranslate } from 'hooks/useTranslate';
import { ReflectionItemContext } from 'pages/Growth/Reflect/components/ReflectionItem/ReflectionItem';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import './EmojiSelector.module.scss';
// =========================

export default function Input({
  emotion,
  emojis,
}: {
  emotion: {
    id: number;
    description: string;
  };
  emojis: (ActivityEntity | undefined)[] | undefined;
}) {
  const translate = useTranslate();
  const inputRef = useRef<HTMLInputElement>(null);

  const { saveState, setSaveState, save, reflection } = useContext(
    ReflectionItemContext
  );

  const [editing, setEditing] = useState(false);

  useEffect(() => {
    //   focus on input if new item is added
    if (reflection?.emotions.find((e) => e.id === emotion.id) === undefined) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, []);

  function handleChange(
    event: React.ChangeEvent<HTMLInputElement>,
    emoji: number
  ) {
    setEditing(true);
    setSaveState((prev) => ({
      ...prev,
      emotions: prev.emotions.map((e) =>
        e.id === emoji ? { ...e, description: event.target.value } : e
      ),
    }));
  }

  function handleSubmit(e?: React.FormEvent<HTMLFormElement>) {
    if (e.type === 'keydown') {
      // do not prevent default action, so that we move with tab to next input
    } else {
      e?.preventDefault();
      inputRef.current?.blur();
    }
    setEditing(false);

    save({
      ...saveState,
      emotions: saveState.emotions,
    });
  }

  useOnClickOutside({
    refs: [inputRef],
    handler: handleSubmit,
    condition: editing,
  });

  return (
    <motion.div styleName="card" {...framerFade}>
      <p>
        {emojis?.find((emoji) => emoji?.id === emotion.id)?.name}{' '}
        {translate('general.terms.because')}
      </p>
      <input
        type="text"
        ref={inputRef}
        placeholder={translate('project.terms.describe-reason') as string}
        onChange={(event) => handleChange(event, emotion.id)}
        value={emotion.description}
        maxLength={90}
      />
    </motion.div>
  );
}
